import React, { useState,  useEffect } from 'react'
import { Button,  Flex, Table,   Tag} from 'antd'
import api, { BASEURL } from '../../service/axios'
import { useToasts } from 'react-toast-notifications';
import {
    LoadingOutlined,
    FilePdfOutlined
} from '@ant-design/icons';
import { userState } from '../../service/database'
import { useRecoilState } from 'recoil'
import dayjs from 'dayjs';
import "./certificadopj.css"
import { responseMessage } from '../../service/util';






export const CertificadoPJ = (props) => {

    const [loading, setLoading] = useState(false)
    const { addToast } = useToasts()
    const [data, setData] = useState([])
    const [user, setUser] = useRecoilState(userState)
 

    const [pdfUrl, setPdfUrl] = useState(undefined)


    useEffect(() => {
        load()
        gerarPDF()
    }, [])


    async function load() {
        try {
            setLoading(true)
            const result = await api.get('api/v1.0/registrado/certificados/pj',
                {
                    headers: {
                        'x-access-token': user?.token2
                    },
                    params: {
                    }
                }
            )
            setData(result.data)
            console.log(result.data)
        } catch (error) {
            addToast(responseMessage(error.message), { appearance: 'error', autoDismiss: true })
        }
        setLoading(false)
    }

    async function gerarPDF() {
        try {
            setLoading(true)
            const result = await api.get('api/v1.0/registrado/certificado/pj',
                {
                    headers: {
                        'x-access-token': user?.token2
                    },
                    params: {
                    },
                    responseType: 'blob'
                }
            )

            console.log(result.data)

            const pdfBlob = new Blob([result.data], { type: "application/pdf" });
            // Cria uma URL temporária para o Blob 
            const url = window.URL.createObjectURL(pdfBlob);
            // Cria         um elemento <a> temporário para iniciar o download 
           

            setPdfUrl(url)

        } catch (error) {
            addToast(responseMessage(error.message), {
                appearance: 'error', autoDismiss: true
            })
        }
        setLoading(false)
    }


    return <Flex vertical>
        {loading && <Flex align='center' gap={5}>
            <LoadingOutlined />
            carregando...
        </Flex>}
        {pdfUrl && (
            <div style={{ marginTop: '20px', height: '600px' }}>
                <iframe
                    src={pdfUrl}
                    width="100%"
                    height="100%"
                    title="PDF Viewer"
                />
            </div>
        )}
    </Flex>



    return <Flex vertical flex={1} >
        <Flex justify='space-between' style={{ marginBottom: 5 }}>
            <Flex>Certificados Emitidos:</Flex>
            <Button
                loading={loading}
                size='small' icon={<FilePdfOutlined />}
                onClick={async () => {

                    try {
                        setLoading(true)
                        const result = await api.get('api/v1.0/registrado/certificado/pj',
                            {
                                headers: {
                                    'x-access-token': user?.token2
                                },
                                params: {
                                },
                                responseType: 'blob'
                            }
                        )

                        console.log(result.data)

                        /*

                        const pdfBlob = new Blob([result.data], { type: "application/pdf" });
                        // Cria uma URL temporária para o Blob 
                        const url = window.URL.createObjectURL(pdfBlob);
                        // Cria         um elemento <a> temporário para iniciar o download 
                        const tempLink = document.createElement("a");
                        tempLink.href = url;
                        tempLink.setAttribute("download", 'certificado.pdf');
                        // Define o nome de arquivo desejado para o arquivo baixado 
                        // Adiciona o elemento <a> ao corpo e clica nele para iniciar o download 
                        document.body.appendChild(tempLink);
                        tempLink.click();
                        // Limpa os elementos temporários e a URL 
                        document.body.removeChild(tempLink);
                        window.URL.revokeObjectURL(url);

                        */


                    } catch (error) {
                        addToast(error.message, {
                            appearance: 'error', autoDismiss: true
                        })
                    }
                    setLoading(false)
                    load()

                }}>Novo Certificado</Button>
        </Flex>
        <Table
            loading={loading}
            id='tablesmall'
            dataSource={data} size='small' bordered pagination={false}>
            <Table.Column title={'Data'} align='center' render={(txt, item, index) => {
                return dayjs(item.createAt).format('DD/MM/YYYY')
            }} />

            <Table.Column title={'Ramo'} render={(txt, item, index) => {
                return item.ramo
            }} />
            <Table.Column title={'Atividade'} render={(txt, item, index) => {
                return "".concat(item.atividade1, ' ',
                    item.atividade2 ? item.atividade2 : '', ' ',
                    item.atividade3 ? item.atividade3 : '', ' ',
                    item.atividade4 ? item.atividade4 : '')
            }} />

            <Table.Column title={'Validade'} align='center' render={(txt, item, index) => {
                let dias = dayjs().diff(dayjs(item.validade), 'day')
                return <Tag color={dias > 0 ? 'red' : 'blue'}> {dayjs(item.validade).format('DD/MM/YYYY')} </Tag>
            }} />

            <Table.Column title={''} align='center' render={(txt, item, index) => {
                return ""
            }} />
        </Table>
    </Flex>

}
export default CertificadoPJ
